import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import { useTranslation } from 'react-i18next';

export default function ClientCommentsDialog(props) {

    const classes = useStyles();

    const { t } = useTranslation();

    return (

        <Dialog className={classes.dialogContainer}
            open={props.dialogOpen}
            aria-labelledby="draggable-dialog-title"
            onClose={props.closeDialog}
        >
            <DialogTitle className={classes.dialogTitle} id="draggable-dialog-title">
                {t("Client comments")}
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <div className={classes.commentsContainer}>
                    {/* {props.comments.match(/.{1,60}/g).map(x => <div>{x}</div>)} */}
                    {props.comments}
                </div>
            </DialogContent>
            <DialogActions>
                <div className={classes.buttons}>
                    <Button className={classes.closeButton} autoFocus onClick={props.closeDialog}>
                        CLOSE
                 </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
}

const useStyles = makeStyles(() => ({

    dialogContainer: {
        "& > div > div": {
            width: "700px !important",
            maxWidth: "none !important",
        },
        margin: "auto",

    },
    buttons: {
        width: "700px",
        textAlign: "center"
    },
    closeButton: {
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        backgroundColor: FlagstoneTheme.palette.primary.main,
        '&:hover': {
            backgroundColor: FlagstoneTheme.palette.primary.main,
        },
        margin: "3px",
        width: "50px",
        marginBottom: "20px"
    },
    dialogTitle: {
        color: "#000000",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "left",
        '& h2': {
            fontSize: "32px !important",
        },
        paddingTop: "20px",
        cursor: 'move',
    },
    dialogContent: {
        backgroundColor: "#FFF8DB",
        height: "100%",
        padding: "3%",
        margin: "20px",
        boxSizing: 'border-box'
    }
}));
